import { render, staticRenderFns } from "./AddingDraft.vue?vue&type=template&id=262e79a8"
import script from "./AddingDraft.vue?vue&type=script&lang=js"
export * from "./AddingDraft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports